
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phenotypes",
      function () {
        return require("private-next-pages/phenotypes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phenotypes"])
      });
    }
  